import { Button, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore.ts'
import { ModalLargeIcon } from 'shared/ui/Icon/ModalLargeIcon/ModalLargeIcon.tsx'
import { ModalTypeList } from 'shared/ui/Modal/store/types.ts'
import { AuthPath } from 'pages/auth/route/authPath.ts'
import { AuthHeader } from 'pages/auth/ui/AuthHeader/AuthHeader.tsx'
import styles from './styles.module.scss'

export const ExpiredForm = () => {
  const onClick = () => {
    uiStore.changeRoute({
      path: `/${AuthPath.login}`,
    })
  }
  return (
    <div className={styles.wrap}>
      <AuthHeader />
      <div className={styles.content}>
        <ModalLargeIcon type={ModalTypeList.FAIL} />
        <Typography
          marginTop={24}
          variant={'heading-lg'}
          ariaLabel={'title'}
          color={'var(--content-primary-primary)'}
        >
          Your link has expired
        </Typography>
        <Typography
          marginTop={8}
          variant={'body-lg-regular'}
          ariaLabel={'subtitle'}
          color={'var(--content-primary-tertiary)'}
        >
          Please request a new password reset link
        </Typography>
      </div>
      <div className={styles.footer}>
        <Typography
          variant={'body-sm-medium'}
          ariaLabel={'signInLink'}
          color={'var(--content-primary-tertiary)'}
        >
          Already have a Salesmsg account?
          <Button onClick={onClick} typeBtn={'link'} text={'Sign in'} />
        </Typography>
      </div>
    </div>
  )
}

export default ExpiredForm
